import { pathOr } from 'ramda';

import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';

interface IParams {
  offer: Pick<IDailyRentOfferForMobileSite, 'isCianPartner' | 'externalOfferUrl' | 'dealType' | 'offerType' | 'cianId'>;
  checkInDate?: string | number | null;
  checkOutDate?: string | number | null;
  minBeds?: number;
}

export const prepareOfferUrl = ({ offer, checkInDate, checkOutDate, minBeds }: IParams): string => {
  const isCianPartner = pathOr(false, ['isCianPartner'], offer);
  const externalOfferUrl = pathOr(null, ['externalOfferUrl'], offer);

  const hasBothDates = checkInDate && checkOutDate;

  if (isCianPartner && externalOfferUrl) {
    return externalOfferUrl;
  }

  const queryParams = [
    hasBothDates && `checkin=${checkInDate}`,
    hasBothDates && `checkout=${checkOutDate}`,
    minBeds && minBeds > 1 ? `min_beds=${minBeds}` : undefined,
  ]
    .filter(Boolean)
    .join('&');

  const searchString = queryParams ? `?${queryParams}` : '';

  return `/${offer.dealType}/${offer.offerType}/${offer.cianId}/${searchString}`;
};
